import { render, staticRenderFns } from "./Tipocomponente.vue?vue&type=template&id=fee14bd8&scoped=true&"
import script from "./Tipocomponente.vue?vue&type=script&lang=js&"
export * from "./Tipocomponente.vue?vue&type=script&lang=js&"
import style0 from "./Tipocomponente.vue?vue&type=style&index=0&id=fee14bd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee14bd8",
  null
  
)

export default component.exports